import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';

class ModalAguarde extends AbstractComponent {        
    fechar() {                
        if(this.props.fechar !== undefined) {
            this.props.fechar();
        }
    }    

    styleList(i) {
        if(i === 0)
            return {
                marginBottom: '25px',
                fontWeight: '700'
            };

        return {listStyle: 'circle'}
    }    
        
    styleHeader() {                
        return (this.props.styleHeader === undefined) ? "bg-white" : this.props.styleHeader;
    }

    styleIcon() {
        return (this.props.styleIcon === undefined) ? "" : this.props.styleIcon;
    }

    styleText() {
        return (this.props.styleText === undefined) ? "text-dark" : this.props.styleText;        
    }        

    show() {
        if(!this.props.show)
            return ;

        return (
            <div 
                className={"modal " + this.className} 
                tabIndex="-1" 
                role="dialog" 
                style={{display: 'block'}}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        {
                            this.props.header !== "" &&
                            <div className={"modal-header " + this.styleHeader()}>
                                <div className="col-md-10                                 
                                                col-sm-10                                                
                                                col-lg-10                                                
                                                col-xs-10"> 
                                    <h4>
                                        <i className={this.styleIcon()}/> {this.props.header}
                                    </h4>
                                </div>                                
                            </div>
                        }

                        <div className="modal-body">
                            <div 
                                className={this.styleText()} 
                                style={{
                                    wordWrap: 'break-word', 
                                    marginBottom: '15px',
                                    textAlign: 'center'
                                }}>

                                <img src={this.props.src} alt={this.props.alt} width={this.props.width} />                                                    
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <Fragment>
                {this.show()}            
            </Fragment>
        )
    }
}

ModalAguarde.defaultProps = {
    textoArray: []
}

export default ModalAguarde;